import { __assign, __extends } from "tslib";
import React from "react";
import { Text, View } from "react-native";
import moment from "moment";
import styles from "./PnmacMessageCenter.styles.js";
import PnmacTabs from "../Tabs/PnmacTabs";
import Inbox from "./components/Inbox";
import Sent from "./components/Sent";
import Compose from "./components/Compose";
import { textStyle } from '../v2/theme';
var PnmacMessageCenter = /** @class */function (_super) {
  __extends(PnmacMessageCenter, _super);
  function PnmacMessageCenter(props) {
    var _this = this;
    var _a;
    _this = _super.call(this, props) || this;
    _this.navigate = function (view) {
      _this.setState({
        page: view,
        reply: false
      });
    };
    var fromChat = (((_a = props.route) === null || _a === void 0 ? void 0 : _a.params) || {}).fromChat;
    _this.state = {
      page: _this.props.fromChat || fromChat ? "compose" : "inbox",
      reply: false,
      routes: {
        inbox: Inbox,
        sent: Sent,
        compose: Compose
      }
    };
    _this.refrence = /*#__PURE__*/React.createRef();
    if (props.navigation) {
      props.navigation(_this.navigate);
    }
    return _this;
  }
  PnmacMessageCenter.prototype.render = function () {
    var _this = this;
    var _a = this.state,
      routes = _a.routes,
      page = _a.page,
      sentTabTitle = _a.sentTabTitle,
      inboxTabTitle = _a.inboxTabTitle,
      composeTabTitle = _a.composeTabTitle;
    var small = this.props.matches.small;
    var tdata = page === "inbox" ? (this.props.messages || []).filter(function (s) {
      return s.direction !== 200269;
    }).map(function (s) {
      return [moment(s.receivedDateTimeUtc).format("MM/DD/YYYY"), s.loanId, s.from, s.subject, s.message, s.subjectLID, s.messageId, s.messageRead, s.chatLog, s.hasAttachment];
    }) : (this.props.messages || []).filter(function (s) {
      return s.direction == 200269;
    }).map(function (s) {
      return [moment(s.receivedDateTimeUtc).format("MM/DD/YYYY"), s.loanId, s.from, s.subject, s.message, s.subjectLID, s.messageId, s.messageRead, s.chatLog, s.hasAttachment];
    });
    var RenderElement = function () {
      return /*#__PURE__*/React.createElement(routes[page], __assign({
        small: small,
        ref: _this.refrence,
        tableData: tdata,
        reply: _this.state.reply,
        setReply: function (data) {
          return _this.setState({
            reply: data
          });
        },
        tableHead: _this.props.tableHeader,
        navigate: _this.navigate
      }, _this.props));
    };
    return /*#__PURE__*/React.createElement(View, {
      style: styles.messageContainer,
      testID: "messageCenter"
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(PnmacTabs, {
      small: true,
      selected: this.state.page,
      style: {
        width: small ? "100%" : "25%",
        justifyContent: "flex-start",
        paddingRight: 10
      },
      iconStyle: __assign({
        height: "auto",
        borderWidth: 1,
        padding: 10,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        marginRight: 4
      }, textStyle.nonActiveTab),
      selectedIconStyle: __assign({
        height: "auto",
        color: "#FFF",
        marginRight: 4
      }, textStyle.activeTab),
      onSelect: function (el) {
        if (_this.props.onTabChange) {
          _this.props.onTabChange(el);
        }
        if (_this.refrence.current) {
          _this.setState({
            page: el.props.name,
            reply: false
          }, function () {
            return _this.refrence.current.setState({
              showing: -1
            });
          });
        } else {
          _this.setState({
            page: el.props.name,
            reply: false
          });
        }
      }
    }, /*#__PURE__*/React.createElement(Text, {
      accessibilityLabel: 'Inbox',
      name: "inbox",
      style: page === 'inbox' ? textStyle.activeTabText : textStyle.nonActiveTabText
    }, inboxTabTitle || "Inbox", " ( ", this.props.inboxMessageCount, " )"), /*#__PURE__*/React.createElement(Text, {
      accessibilityLabel: 'Sent',
      name: "sent",
      style: page === 'sent' ? textStyle.activeTabText : textStyle.nonActiveTabText
    }, sentTabTitle || "Sent"), /*#__PURE__*/React.createElement(Text, {
      accessibilityLabel: 'Compose',
      name: "compose",
      style: page === 'compose' ? textStyle.activeTabText : textStyle.nonActiveTabText
    }, composeTabTitle || "Compose"))), /*#__PURE__*/React.createElement(View, {
      style: {
        marginRight: 10
      }
    }, RenderElement()));
  };
  return PnmacMessageCenter;
}(React.Component);
PnmacMessageCenter.defaultProps = {
  inboxMessageCount: 0
};
export default PnmacMessageCenter;